import { render } from "./FaqElement.vue?vue&type=template&id=68cd8e04"
import script from "./FaqElement.vue?vue&type=script&lang=js"
export * from "./FaqElement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__